<template>
	<IconButtonLayout class="close-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:class="iconClass"
				:icon="[ `fas`, `times`]"
				@click="$emit( `close` )"
			/>
		</template>

	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "CloseButton",
	emits: [ "close", ],
	components: {
		IconButtonLayout,
	},
};
</script>

<style lang="scss" scoped></style>
